<template>
  <div>
    <accnav
      :list="navList"
      :curTitleId="curTitleId"
      @titleChange="titleChange"
    ></accnav>
    <div>
      <liveList :liveType="curTitleId"></liveList>
    </div>
  </div>
</template>

<script>
import accnav from '../../common/accnav.vue'
import liveList from './children/liveList.vue'
export default {
  data: function () {
    return {
      curTitleId: 1, //  1 学习记录   2 我的收藏  3重点课程
      navList: [{
        id: 1,
        name: '正在直播',
      },{
        id: 2,
        name: '直播预告',
      },{
        id: 3,
        name: '直播回放',
      }],
      loading: false,
    }
  },
  computed: {

  },
  components:{accnav, liveList},
  methods:{
    titleChange: function (id) {
      this.curTitleId = id
    },
    toCourseDetail: function (id) {
      this.$router.push({
          path : 'CourseDetail',
          query : {id : id},
      })
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>
  .task_list{
    position: relative;
  }
.task-pagination{
  text-align: center;
  position: absolute;
  bottom: 20px;
  width: 100%;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AccLive/AccLive.vue